import { styled as styledMui, Box } from "@mui/material";

export const StyledBadgeBox = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  width: "fit-content",
  borderRadius: "6px",
  padding: "4px 10px",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: 1.3,
  whiteSpace: "nowrap",
  pointerEvents: "none",
  boxSizing: "border-box",
});
